import { get } from '@eika-infrastruktur/request';

import { KundeSigneringsordrerResponse } from '../generated-types';
import { CONTEXT_PATH } from './index';

const SERVICE_PATH = `rest/resource/signeringsordre`;

export const getSigningOrders = (includeInFlow: boolean) =>
    get<KundeSigneringsordrerResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}?includeInFlow=${includeInFlow.toString()}`);

export const getSigningOrderById = (signingOrderId: number) =>
    get<KundeSigneringsordrerResponse>(`${CONTEXT_PATH}/${SERVICE_PATH}/${signingOrderId}`);
